export const ENTITLEMENT = 'entitlement';
